/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import {
  STATUS_BAR_MODULE_SELECTED,
  DISABLE_TASK_BAR_BUTTON_NAVIGATION
} from '../actions/button-click.actions';

import { ButtonsState } from '../buttons-state';
import { ROUTES } from 'src/app/core/constants/routes';

const getButtonsFeatureState = createFeatureSelector<ButtonsState>('buttons');

export const selectModuleName = createSelector(selectSelectedModule, (state) => state);

export const isNavigationDisabled = createSelector(
  getButtonsFeatureState,
  (buttonsState: ButtonsState) => buttonsState && buttonsState.isNavigationDisabled
);

const initialState: ButtonsState = {
  taskBarButton: '',
  isNavigationDisabled: false,
  previousModule: ''
};

export const buttonsReducer = createReducer<ButtonsState>(
  initialState,
  on(STATUS_BAR_MODULE_SELECTED, (state: ButtonsState, { button }): ButtonsState => {
    const previousModule = localStorage.getItem('selectedModule') || '';
    localStorage.setItem('previousModule', previousModule);
    localStorage.setItem('selectedModule', button);
    return {
      ...state
    };
  }),
  on(
    DISABLE_TASK_BAR_BUTTON_NAVIGATION,
    (state: ButtonsState, { isNavigationDisabled }): ButtonsState => {
      return {
        ...state,
        isNavigationDisabled: isNavigationDisabled
      };
    }
  )
);

function selectSelectedModule(): string {
  const selectedModule = localStorage.getItem('selectedModule')! as string;
  return selectedModule === 'undefined' || selectedModule == null
    ? ROUTES.HOME_BETTING
    : selectedModule;
}
